__turbopack_context__.v({
  "carouselContainer": "TabControlledCarousel-module__nLVzwa__carouselContainer",
  "carouselSlide": "TabControlledCarousel-module__nLVzwa__carouselSlide",
  "carouselTrack": "TabControlledCarousel-module__nLVzwa__carouselTrack",
  "floaterSpan": "TabControlledCarousel-module__nLVzwa__floaterSpan",
  "iconContainer": "TabControlledCarousel-module__nLVzwa__iconContainer",
  "navButton": "TabControlledCarousel-module__nLVzwa__navButton",
  "nextButton": "TabControlledCarousel-module__nLVzwa__nextButton" + " " + "TabControlledCarousel-module__nLVzwa__navButton",
  "prevButton": "TabControlledCarousel-module__nLVzwa__prevButton" + " " + "TabControlledCarousel-module__nLVzwa__navButton",
  "tab": "TabControlledCarousel-module__nLVzwa__tab",
  "tabsBar": "TabControlledCarousel-module__nLVzwa__tabsBar",
  "tabsContainer": "TabControlledCarousel-module__nLVzwa__tabsContainer",
});
